// extracted by mini-css-extract-plugin
export var breadcrumbsItem = "breadcrumbs-module--breadcrumbs-item--ojmvN";
export var breadcrumbsLink = "breadcrumbs-module--breadcrumbs-link--F-F4e";
export var breadcrumbsSeparator = "breadcrumbs-module--breadcrumbs-separator--34Hkt";